import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/NewsletterForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/blogArticle.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/highlight.js/styles/atom-one-dark.css");
